import type { EmailSubscription } from '@/types/email'

export const EmailSubscriptionFactory = {
  create: (data?: Partial<EmailSubscription>): EmailSubscription => ({
    id: data?.id,
    listId: data?.listId || '',
    email: data?.email || '',
    subscribedAt: data?.subscribedAt || new Date(),
    status: data?.status || 'active',
    createdAt: data?.createdAt || new Date(),
    updatedAt: data?.updatedAt || new Date(),
    ...(data || {}),
  }),
}
